export default __webpack_public_path__ + "static/media/tf.2e194377.png";